import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { Header } from '@hz-design-system/web-ui';

import '../../../scss/global.scss';

export default () => {
  const headerConfig = window.__HEADER_CONFIG__ || {};

  // Header is server side rendered in express-react library
  hydrateRoot(document.getElementById('header-root'), <Header headerConfig={headerConfig} />);
};
